import { useSyncExternalStore } from 'react';

/*
 * A page asking the drawer to stand on its opening question, held in the module
 * for the same reason the drawer's own state is: the panel that has to answer
 * and the page that asks are nowhere near each other in the tree.
 *
 * Counted rather than flagged, because asking twice has to land twice — on a
 * desktop the drawer is already open, so a second ask that changed nothing
 * would look like a dead button.
 */
let asked = 0;

const listeners = new Set<() => void>();

/** How often anyone has asked so far. */
export function currentChatOpeningAsked(): number {
  return asked;
}

/** Ask the drawer for this page's opening question, from anywhere. */
export function askChatForOpening(): void {
  asked += 1;
  listeners.forEach((listener) => listener());
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);

  return () => {
    listeners.delete(listener);
  };
}

/** The count, as the drawer reads it: reactively, from wherever it is drawn. */
export function useChatOpeningAsked(): number {
  return useSyncExternalStore(subscribe, currentChatOpeningAsked, () => 0);
}
